import Icon from '../components/Icon.vue'

Icon.register({
  reply: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M8.3 189.8l176-152c15.4-13.3 39.7-2.5 39.7 18.2v80.1c160.6 1.8 288 34 288 186.3 0 61.4-39.6 122.3-83.3 154.1-13.7 9.9-33.1-2.5-28.1-18.6 45.3-145-21.5-183.5-176.6-185.7v87.9c0 20.7-24.3 31.5-39.7 18.2l-176-152c-11.1-9.6-11.1-26.8 0-36.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/reply.js
// module id = 1837
// module chunks = 0